export default __webpack_public_path__ + "static/media/mb-q-chevron.6133256e.svg";